// extracted by mini-css-extract-plugin
export var checkbox = "_9e-0";
export var circle = "_9e-3";
export var horizontalContainer = "_9e-7";
export var sm = "_9e-5";
export var switch0 = "_9e-2";
export var switchDisabled = "_9e-8";
export var switchEnabled = "_9e-1";
export var textSwitchContainer = "_9e-9";
export var textSwitchOption = "_9e-a";
export var textSwitchOptionSelected = "_9e-b";
export var verticalContainer = "_9e-6";
export var xs = "_9e-4";